var _DesignPresetsNamespace_instances, _DesignPresetsNamespace_getWidgetPresets;
import { __classPrivateFieldGet } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { createDesignPresetsError, DesignPresetsErrorCode } from './errors';
export class DesignPresetsNamespace extends PrivateAPINamespace {
    constructor() {
        super(...arguments);
        _DesignPresetsNamespace_instances.add(this);
    }
    setDesignPreset(compRef, presetId) {
        this.ps.ds.appStudioWidgets.presets.change(compRef, 
        // stylePresetId:
        presetId, 
        // layoutPresetId:
        presetId);
    }
    getDesignPreset(compRef) {
        return this.ps.ds.appStudioWidgets.presets.get(compRef);
    }
    setDesignPresetByName(compRef, presetName) {
        const presets = __classPrivateFieldGet(this, _DesignPresetsNamespace_instances, "m", _DesignPresetsNamespace_getWidgetPresets).call(this, compRef);
        const preset = presets.find((x) => x.name === presetName);
        if (!preset || !preset.id) {
            console.warn(createDesignPresetsError(DesignPresetsErrorCode.UnknownDesignPreset)
                .withPreset(presetName)
                .withAvailablePresets(presets.map((x) => x.name)));
            return;
        }
        this.setDesignPreset(compRef, preset.id);
    }
    async getDesignPresetName(compRef) {
        const preset = await this.getDesignPreset(compRef);
        return __classPrivateFieldGet(this, _DesignPresetsNamespace_instances, "m", _DesignPresetsNamespace_getWidgetPresets).call(this, compRef).find((x) => x.id === preset.layout)
            ?.name;
    }
}
_DesignPresetsNamespace_instances = new WeakSet(), _DesignPresetsNamespace_getWidgetPresets = function _DesignPresetsNamespace_getWidgetPresets(compRef) {
    const stageData = this.ps.ds.appStudioWidgets.getWidgetStageData(compRef);
    const presets = (stageData?.gfpp?.desktop).widgetPresets
        ?.presets;
    if (!presets) {
        return [];
    }
    return presets.map((x) => ({
        id: x.id,
        name: x.name,
    }));
};
DesignPresetsNamespace.namespace = 'designPresets';
//# sourceMappingURL=DesignPresetsNamespace.js.map